import { Component, OnInit } from '@angular/core';
import { ClassData, Grade } from './classes/classdata';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TeacherClassroomService } from './service/teacher-classroom.service';
import { ManagegroupserviceService } from './manage-groups/managegroupservice.service';
import { MyErrorHandler } from '../../../tools/src/lib/errorhandler/errorhandler';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [TeacherClassroomService, ManagegroupserviceService]
})
export class AppComponent implements OnInit {
  title = 'classroom';
  errorHandler: MyErrorHandler;
  classRoomList: any;
  gradeList: any[] = [];
  classData: ClassData;
  NewClassRoomList = [];
  groupListCount=[];
  groupCount: any;
  groupNames: any;
  groupNamesArr: any[] = [];
  showLoader: any;
  grade: Grade;
  gridView = true;
  noOfItems = 10;
  page = 1;
  gradeSelectConfig:any;
  

  filter = {
    grade: ''
  };
  public filterQuery = '';
  public rowsOnPage = 10;
  public sortOrder = 'asc';

  /* Sorting variables */
  propertyName: string;
  propertyNameSorting: string;
  orderType = true;
  isSorted = false;
  sortedClass: string;
  
  term;
  gradeListToRender: any[];
  DifClassRoomList = [];
  loaded = false;
  textDir:any;
  constructor(
    private http: HttpClient,
    private router: Router,
    private routeParams: ActivatedRoute,
    public translate: TranslateService,
    private teacherclassroomService: TeacherClassroomService,
    private managegroupservice: ManagegroupserviceService
    ) {

      this.textDir = sessionStorage.getItem('textDir')
    }

  ngOnInit(): void {
    if (localStorage.getItem('token')) {
      this.translate.get('All grades').subscribe((translated: string) => {
        this.gradeSelectConfig = {
          placeholder: translated,
          displayKey: 'name',
          search: false,
          height: '150px',
        };
      });
      localStorage.setItem('sessionDataForGroup', null);
      this.getClassRoomList();
    } else {
      this.router.navigate(['/login']);
    }
  }

  /***
    * this method will be used to get Teacher classroom List
  */
  getClassRoomList() {
    this.loaded = false;
    this.gradeList = new Array();
    return this.teacherclassroomService.getClassRoomListData().subscribe(
      (response) => {
        this.classRoomList = [...response];
        /* this.classRoomList.sort((a,b) => 0 - (a > b ? -1 : 1)); */
        this.classRoomList.sort((a, b) => a.grade.name.localeCompare(b.grade.name));
        this.classRoomList.forEach(element => {
          if (this.gradeList.length < 1) {
            element.grade.year_no = element.grade.year[0].number;
            this.gradeList.push(element.grade);
          } else if (!this.gradeList.find(x => x.name === element.grade.name)) {
            element.grade.year_no = element.grade.year[0].number;
            this.gradeList.push(element.grade);
          }
        });

        this.gradeListToRender = this.gradeList.sort(this.GetSortOrder('year_no'));

        this.gradeList.forEach(grade => {
          let classes = [];
          this.classRoomList.forEach(element => {
           
            if (element.grade._id === grade._id){
              const eachClass = {_id: '', name: '', grade: [], count: '', groupcount: ''};
              eachClass._id = element._id;
              eachClass.name = element.name;
              eachClass.grade = grade;
              eachClass.count = element.count;
              eachClass.groupcount =  element.groupCount;
              this.getGroupListData(element._id);
              classes.push(eachClass);
            }
          });
          classes = classes.sort(this.GetSortOrder('name'));
          this.NewClassRoomList = this.NewClassRoomList.concat(classes);
          
        });
        console.log("NewClassRoomList >>> ");
            console.log(this.NewClassRoomList)
        this.loaded = true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
        this.showErrorBox();
      },
    );
  }

  GetSortOrder(prop) {
    return (a, b) => {
        if (a[prop] > b[prop]) {
            return 1;
        } else if (a[prop] < b[prop]) {
            return -1;
        }
        return 0;
    };
  }

  /*
   * Method is used to add values in session variables to pass on next page
  */
  manageGroupAndClass(classRoomObj) {
    this.classData = new ClassData();
    this.classData._id = classRoomObj._id;
    this.classData.name = classRoomObj.name;
    this.classData.count = classRoomObj.count;
    this.classData.grade = classRoomObj.grade.name;
    localStorage.setItem('sessionDataForClass', JSON.stringify(this.classData));

    const navigationExtras: NavigationExtras = {
      relativeTo: this.routeParams,
    };
    this.router.navigate(['managegroups'], navigationExtras);
  }

  /**
   *  code for show possible error in notification form
   */
  showErrorBox() {
    this.loaded = true;
    const className = document.getElementById('snack-error-bar');
    className.className = 'show';
  }

  /**
   *  code for close snack notification bar
   */
  closeErrorDiv() {
    const className = document.getElementById('snack-error-bar');
    className.className = className.className.replace('show', '');
  }

  getGroupListData(classId){
    this.managegroupservice.getClassGroupListData(classId).subscribe(
      (response) => {
        if (response != null && response.length > 0) {
          const groupsArr = Object.values(response);
          const  groupDataArr = [];
          this.groupListCount.push(response.length);
         
          groupsArr.forEach((item: any, i) => {
            groupDataArr[i] = item.name;
          });
          this.groupNames = groupDataArr.join(', ');
          this.groupNamesArr[classId] = groupDataArr.join(', ');
        }
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        this.errorHandler = errorHandlerObj.handleError(err);
        if (this.errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
        this.showErrorBox();
      },
      () => {
        this.showLoader = false;
      }
    );
  }
  setGrid() {
    this.gridView = true;
    this.noOfItems = 9;
  }
  setList() {
    this.gridView = false;
    this.noOfItems = 18;
  }

  /* Sorting functionality added - KAJAL */
  sortByDefault(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    this.orderType = true;
    this.propertyNameSorting = propertyName;
  }
  sortBy(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    if (propertyName !== null && this.propertyName === propertyName){
      if (this.orderType === true){
        this.orderType = false;
        this.propertyNameSorting = propertyName;
        this.sortedClass = 'asc';
      }else{
        this.orderType = true;
        this.propertyNameSorting = '-' + propertyName;
        this.sortedClass = 'desc';
      }
    }
  }
  alertme(filter) {
     alert('filter ' + JSON.stringify(filter));
  }
}
